module.exports = {"130521103":"晏家屯镇","130521104":"南石门镇","130521105":"羊范镇","130521106":"皇寺镇","130521107":"会宁镇","130521108":"西黄村镇","130521109":"路罗镇","130521110":"将军墓镇","130521111":"浆水镇","130521112":"宋家庄镇","130521200":"太子井乡","130521201":"龙泉寺乡","130521202":"北小庄乡","130521203":"城计头乡","130521204":"白岸乡","130521206":"冀家村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130521.json
// module id = 221
// module chunks = 0